export default {
  init() {

  },
  finalize() {
    // add 'news' to breadcrumb, can this be done beter via PHP/hooks?
    const newsPerma = $('#single-bc-news').data('news-perma');
    const $newsItem = $(`<a href="${newsPerma}">News</a>`);
    $('.global-breadcrumbs #breadcrumbs').find('a').after($newsItem);
  },
}


// WEBPACK FOOTER //
// ./scripts/routes/single-post.js